import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

import { DeluxeBoatComponent } from './deluxe-boat/deluxe-boat.component';
import { VipBoatComponent } from './vip-boat/vip-boat.component';
import { VvipBoatComponent } from './vvip-boat/vvip-boat.component';

import { OpenTripKomodoComponent } from './open-trip-komodo/open-trip-komodo.component';
import { OpenTripOutsideKomodoComponent } from './open-trip-outside-komodo/open-trip-outside-komodo.component';
import { AlorIslandComponent } from './alor-island/alor-island.component';
import { BandaIslandComponent } from './banda-island/banda-island.component';
import { KomodoNationalParkComponent } from './komodo-national-park/komodo-national-park.component';
import { RajaAmpatComponent } from './raja-ampat/raja-ampat.component';


import { AboutUsComponent } from './about-us/about-us.component';

import { LoginPelangganComponent } from './login-pelanggan/login-pelanggan.component';
import { LoginWaComponent } from './login-wa/login-wa.component';
import { LoginDaftarComponent } from './login-daftar/login-daftar.component';

import { DetailBoatComponent } from './detail-boat/detail-boat.component';

import { BookingComponent } from './booking/booking.component';

import { BookingPelangganComponent } from './booking-pelanggan/booking-pelanggan.component';



import { Authguard } from './shared/authguard.guard';
import { DetailBookingComponent } from './detail-booking/detail-booking.component';
import { DetailBoatopenComponent } from './detail-boatopen/detail-boatopen.component';
import { DetailBoatoutsideComponent } from './detail-boatoutside/detail-boatoutside.component';

import { AccountComponent } from './account/account.component';
import { AccountPhoneNumberComponent } from './account-phone-number/account-phone-number.component';
import { HasilCariComponent } from './hasil-cari/hasil-cari.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'deluxe-boat', component: DeluxeBoatComponent },
  { path: 'vip-boat', component: VipBoatComponent },
  { path: 'vvip-boat', component: VvipBoatComponent},
  { path: 'vvip-boat', component: VvipBoatComponent},
  { path: 'open-trip-komodo', component: OpenTripKomodoComponent},
  { path: 'open-trip-outside-komodo', component: OpenTripOutsideKomodoComponent},
  { path: 'alor-island', component: AlorIslandComponent},
  { path: 'banda-island', component: BandaIslandComponent},
  { path: 'komodo-national-park', component: KomodoNationalParkComponent},
  { path: 'raja-ampat', component: RajaAmpatComponent},

  { path: 'detail-boat/:slug', component: DetailBoatComponent },
  { path: 'detail-boatopen/:slug', component: DetailBoatopenComponent },
  { path: 'detail-boatoutside/:slug', component: DetailBoatoutsideComponent },

  // { path: 'open-trip', component: OpenTripComponent },
  // { path: 'destinations', component: DestinationsComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'blog', component: BlogComponent },
  { path: 'blog/:slug', component: BlogDetailComponent },
  { path: 'login-pelanggan', component: LoginPelangganComponent},



  { path: 'login-pelanggan/whatsapp', component: LoginWaComponent },
  { path: 'signup-pelanggan', component: LoginDaftarComponent },
  {
    path: 'l_admin',
    loadChildren: () => import('./l_admin/l_admin.module').then(m => m.LAdminModule)  // Lazy load modul admin
  },
  { path: 'checkout', component: BookingComponent },

  { path: 'bookings', component: BookingPelangganComponent , canActivate: [Authguard]}, //harus login
  { path: 'account', component: AccountComponent , canActivate: [Authguard]}, 
  { path: 'account/phone-number', component: AccountPhoneNumberComponent , canActivate: [Authguard]}, 
  { path: 'detail-booking/:kode_booking', component: DetailBookingComponent, canActivate: [Authguard] },

  { path: 'search-results', component: HasilCariComponent },


  { path: '**', redirectTo: '/home' }  // Fallback jika rute tidak ditemukan
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

